import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from "recharts";
import ChartCard, { CHART_COLORS, TOOLTIP_STYLE } from "@/components/charts/ChartCard";

export default function DonutChart({ title, subtitle, data = [], testid, className }) {
  const rows = data.filter((d) => d.count > 0);
  return (
    <ChartCard title={title} subtitle={subtitle} testid={testid} className={className} empty={rows.length === 0 ? "No data for this period" : null}>
      <ResponsiveContainer width="100%" height={260}>
        <PieChart>
          <Pie data={rows} dataKey="count" nameKey="name" innerRadius={55} outerRadius={90} paddingAngle={2}>
            {rows.map((_, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}
          </Pie>
          <Tooltip contentStyle={TOOLTIP_STYLE} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
        </PieChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
